// import React, { useEffect, useRef } from 'react';

// const RainCanvas = () => {
//   const canvasRef = useRef(null);

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');

//     const resizeCanvas = () => {
//       canvas.width = window.innerWidth;
//       canvas.height = window.innerHeight;
//     };
    
//     resizeCanvas();
//     window.addEventListener('resize', resizeCanvas);

//     // Setup rain drops
//     const maxDrops = 150;
//     const drops = Array.from({ length: maxDrops }, () => ({
//       x: Math.random() * window.innerWidth,
//       y: Math.random() * window.innerHeight,
//       length: Math.random() * 20 + 10,
//       speed: Math.random() * 15 + 10,
//       opacity: Math.random() * 0.3 + 0.1,
//     }));

//     // Text Animation State
//     let textY = window.innerHeight / 2;
//     let textDirection = 1;
//     const textSpeed = 0.6;

//     let animationId;
//     const draw = () => {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
      
//     //   // 1. DRAW ANIMATED TEXT (Left side)
//     //   ctx.save();
//     //   // Subtle float animation up and down
//     //   textY += textSpeed * textDirection;
//     //   if (textY > window.innerHeight / 2 + 15 || textY < window.innerHeight / 2 - 15) {
//     //     textDirection *= -1;
//     //   }

//     //   ctx.font = 'bold 36px sans-serif';
//     //   ctx.fillStyle = 'rgba(174, 194, 224, 0.9)';
//     //   ctx.shadowBlur = 10;
//     //   ctx.shadowColor = 'rgba(174, 194, 224, 0.5)';
      
//     //   // Draw text vertically aligned on the left
//     //   ctx.fillText('Happy Monsoon 🌧️', 40, textY);

//     //   ctx.restore();






// // // 1. DRAW ANIMATED TEXT (Right side)
// //       ctx.save();
// //       // Subtle float animation up and down
// //       textY += textSpeed * textDirection;
// //       if (textY > window.innerHeight / 2 + 15 || textY < window.innerHeight / 2 - 10) {
// //         textDirection *= -1;
// //       }

// //       ctx.font = 'bold 36px sans-serif';
// //       ctx.fillStyle = 'rgba(107, 92, 240, 0.9)';
// //       ctx.shadowBlur = 10;
// //       ctx.shadowColor = 'rgba(174, 194, 224, 0.5)';
      
// //       // NEW: Align text from its right edge instead of the left edge
// //       ctx.textAlign = 'right'; 
      
// //       // NEW: Position it relative to canvas width (canvas.width - padding)
// //       ctx.fillText('Happy Monsoon', canvas.width - 40, textY);
// //       ctx.restore();


















//       // 2. DRAW RAIN DROPS
//       ctx.lineWidth = 1.5;
//       ctx.lineCap = 'round';






//       drops.forEach((drop) => {
//         ctx.strokeStyle = `rgba(174, 194, 224, ${drop.opacity})`;
//         ctx.beginPath();
//         ctx.moveTo(drop.x, drop.y);
//         ctx.lineTo(drop.x + 1.5, drop.y + drop.length);
//         ctx.stroke();

//         drop.y += drop.speed;
//         drop.x += 0.8;

//         if (drop.y > canvas.height) {
//           drop.y = -drop.length;
//           drop.x = Math.random() * canvas.width;
//           drop.speed = Math.random() * 15 + 10;
//         }
//       });

//       animationId = requestAnimationFrame(draw);
//     };

//     draw();

//     return () => {
//       window.removeEventListener('resize', resizeCanvas);
//       cancelAnimationFrame(animationId);
//     };
//   }, []);

//   return (
//     <canvas
//       ref={canvasRef}
//       style={{
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100vw',
//         height: '500px',
//         zIndex: 1, /* Moved behind the text container */
//         pointerEvents: 'none',
//       }}
//     />
//   );
// };

// export default RainCanvas;



import React, { useEffect, useRef } from 'react';

const RainCanvas = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Setup rain drops
    const maxDrops = 150;
    const drops = Array.from({ length: maxDrops }, () => ({
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight,
      length: Math.random() * 20 + 10,
      speed: Math.random() * 15 + 10,
      opacity: Math.random() * 0.3 + 0.1,
    }));

    // Text Animation State
    let textDegree = 0;

    // --- NEW: LIGHTNING SYSTEM STATE ---
    let lightningOpacity = 0;
    let lightningBolt = [];

    // Generates coordinates for a single jagged lightning bolt path
    const createLightningBolt = () => {
      const startX = Math.random() * canvas.width;
      const segments = [];
      let currentX = startX;
      let currentY = 0;

      while (currentY < canvas.height) {
        // Force the bolt downwards while zig-zagging horizontally
        const nextX = currentX + (Math.random() * 100 - 50);
        const nextY = currentY + (Math.random() * 40 + 20);
        
        segments.push({ x: nextX, y: nextY });
        currentX = nextX;
        currentY = nextY;
      }
      return segments;
    };

    let animationId;
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // --- 1. RENDER LIGHTNING FLASH & BOLTS ---
      // Randomly trigger a flash (approx. 0.5% chance per frame)
      if (lightningOpacity <= 0 && Math.random() < 0.005) {
        lightningOpacity = Math.random() * 0.4 + 0.3; // Set flash brightness
        lightningBolt = createLightningBolt();        // Generate bolt path
      }

      if (lightningOpacity > 0) {
        // Draw the full-screen background screen flash
        ctx.fillStyle = `rgba(230, 240, 255, ${lightningOpacity})`;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Draw the main jagged lightning bolt line
        ctx.save();
        ctx.strokeStyle = `rgba(255, 255, 255, ${lightningOpacity + 0.3})`;
        ctx.lineWidth = Math.random() * 3 + 2;
        ctx.shadowBlur = 20;
        ctx.shadowColor = 'rgba(174, 194, 224, 1)';
        ctx.beginPath();
        
        if (lightningBolt.length > 0) {
          ctx.moveTo(lightningBolt[0].x, 0);
          lightningBolt.forEach(point => ctx.lineTo(point.x, point.y));
        }
        ctx.stroke();
        ctx.restore();

        // Rapidly decay/fade out the lightning effect over time
        lightningOpacity -= 0.04; 
      }

      // --- 2. DRAW ANIMATED TEXT (Right side with sine wave float) ---
      // ctx.save();
      // textDegree += 0.02; 
      // const floatRange = 15; 
      // const baselineY = canvas.height / 2;
      // const animatedY = baselineY + Math.sin(textDegree) * floatRange;

      // ctx.font = 'bold 36px sans-serif';
      // ctx.fillStyle = 'rgba(0, 0, 0, 0.9)';
      // ctx.shadowBlur = 10;
      // ctx.shadowColor = 'rgba(174, 194, 224, 0.5)';
      // ctx.textAlign = 'right'; 
      
      // ctx.fillText('Happy Monsoon 🌧️', canvas.width - 40, animatedY);
      // ctx.restore();

      // --- 3. DRAW RAIN DROPS ---
      ctx.lineWidth = 1.5;
      ctx.lineCap = 'round';

      drops.forEach((drop) => {
        ctx.strokeStyle = `rgba(174, 194, 224, ${drop.opacity})`;
        ctx.beginPath();
        ctx.moveTo(drop.x, drop.y);
        ctx.lineTo(drop.x + 1.5, drop.y + drop.length);
        ctx.stroke();

        drop.y += drop.speed;
        drop.x += 0.8;

        if (drop.y > canvas.height) {
          drop.y = -drop.length;
          drop.x = Math.random() * canvas.width;
          drop.speed = Math.random() * 15 + 10;
        }
      });

      animationId = requestAnimationFrame(draw);
    };

    draw();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      cancelAnimationFrame(animationId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 1,
        pointerEvents: 'none',
      }}
    />
  );
};

export default RainCanvas;
